import React from "react";
import ReactMarkdown from "react-markdown"; // v6
import remarkGfm from "remark-gfm";         // v1
import DOMPurify from "dompurify";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";


// Heurística simples p/ alinhar números e "R$" à direita
function isNumericLike(text) {
    return /^(\s*(R\$\s*)?[\d\.\,]+\s*)$/.test(text);
}

export default function AIMessage({ content, disableLinks = true }) {
    // saneia HTML caso o modelo retorne tags
    const safe = DOMPurify.sanitize(content || "", { USE_PROFILES: { html: true } });

    return (
        <div className="prose max-w-none">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    a: ({ children }) => null,
                    // wrapper com rolagem horizontal em tabelas largas
                    table: ({ node, ...props }) => (
                        <div style={{ overflowX: "auto" }}>
                            <table {...props} />
                        </div>
                    ),
                    thead: ({ node, ...props }) => <thead {...props} />,
                    tbody: ({ node, ...props }) => <tbody {...props} />,
                    th: ({ node, ...props }) => (
                        <th
                            style={{
                                padding: 8,
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                whiteSpace: "nowrap"
                            }}
                            {...props}
                        />
                    ),
                    td: ({ children, node, ...props }) => {
                        const raw = String(children ?? "").trim();
                        const alignRight = isNumericLike(raw);
                        return (
                            <td
                                style={{
                                    padding: 8,
                                    borderBottom: "1px solid #eee",
                                    textAlign: alignRight ? "right" : "left",
                                    whiteSpace: "nowrap"
                                }}
                                {...props}
                            >
                                {children}
                            </td>
                        );
                    },
                    // estilos suaves em listas
                    ul: ({ node, ...props }) => <ul style={{ marginLeft: "1.25rem" }} {...props} />,
                    ol: ({ node, ...props }) => <ol style={{ marginLeft: "1.25rem" }} {...props} />,
                    // code block com rolagem horizontal
                    code: ({ node, inline, className, children, ...props }) => {
                        const match = /language-(\w+)/.exec(className || "");
                        return !inline && match ? (
                            <SyntaxHighlighter
                                language={match[1]}
                                PreTag="div"
                                {...props}
                            >
                                {String(children).replace(/\n$/, "")}
                            </SyntaxHighlighter>
                        ) : (
                            <code {...props} style={{ backgroundColor: "#f5f5f5", padding: "2px 4px", borderRadius: 4 }}>
                                {children}
                            </code>
                        );
                    }
                }}
            >
                {safe}
            </ReactMarkdown>
        </div>
    );
}
